<template>
  <div v-if="!isEmpty" class="p-competing-graph" ref="graph">
    <div class="p-competing-graph__bar" :style="{ width: barWidth + '%' }">
      <p class="p-competing-graph__text" :style="textStyle" ref="text">
        {{ value | separateNumber }}
      </p>
    </div>
  </div>
</template>

<script>
import utils from '@/utils';
export default {
  props: ['max', 'value'],
  data() {
    return {
      textStyle: {
        left: 0,
        right: 'auto'
      }
    };
  },
  computed: {
    isEmpty() {
      return utils.isEmpty(this.value);
    },
    barWidth() {
      if (!this.value) {
        return 0;
      }
      return (this.value / this.max) * 100;
    }
  },
  watch: {
    barWidth: {
      handler() {
        this.setTextPosition();
      },
      immediate: true
    }
  },
  methods: {
    setTextPosition() {
      if (this.isEmpty) {
        return;
      }
      this.$nextTick(() => {
        const maxWidth = this.$refs.graph.parentElement.clientWidth;
        const graphWidth = this.$refs.graph.clientWidth;
        const barWidth = (graphWidth * this.barWidth) / 100;
        const textWidth = this.$refs.text.clientWidth;
        const width = Math.ceil(barWidth + textWidth);
        if (width > maxWidth) {
          this.textStyle = {
            left: 'auto',
            right: 0,
            'white-space': 'normal'
          };
        } else {
          this.textStyle = {
            left: this.barWidth + '%',
            right: 'auto'
          };
        }
      });
    }
  }
};
</script>
